/*
 * Heading Fix
 * Replaces <p class="h1">..<p class="h6"> with proper heading tags.
 * Preserves all existing classes and attributes so styling is unaffected.
 * Uses MutationObserver to catch dynamically loaded content.
 * 
 * Asset: assets/heading-fix.js
 * Loaded via: layout/theme.liquid
 * SOP: If theme is updated and this stops working, re-add the
 *      script reference line in theme.liquid (see below).
 */
(function(){
  function fixHeadings(root){
    for(var i=1;i<=6;i++){
      (root||document).querySelectorAll('p.h'+i).forEach(function(p){
        var h=document.createElement('h'+i);
        Array.from(p.attributes).forEach(function(attr){
          h.setAttribute(attr.name,attr.value);
        });
        h.innerHTML=p.innerHTML;
        p.parentNode.replaceChild(h,p);
      });
    }
  }

  function init(){
    fixHeadings();
    new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        m.addedNodes.forEach(function(node){
          if(node.nodeType===1) fixHeadings(node.parentNode);
        });
      });
    }).observe(document.body,{childList:true,subtree:true});
  }

  if(document.body){
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();